import {
  MAX_MAIL_BYTES,
  MAX_MAIL_FILES,
  validateMailAttachments,
  type MailAttachment,
} from "../../../../supabase/functions/_shared/mailAttachments";

export const filesToPayload = async (
  files: File[],
): Promise<MailAttachment[]> => {
  if (
    files.length > MAX_MAIL_FILES ||
    files.reduce((sum, file) => sum + file.size, 0) > MAX_MAIL_BYTES
  )
    throw new Error("Можно прикрепить до 10 файлов общим размером до 15 МБ");
  return validateMailAttachments(
    await Promise.all(
      files.map(async (file) => {
        const bytes = new Uint8Array(await file.arrayBuffer());
        let binary = "";
        for (let offset = 0; offset < bytes.length; offset += 0x8000)
          binary += String.fromCharCode(
            ...bytes.subarray(offset, offset + 0x8000),
          );
        return {
          filename: file.name,
          contentType: file.type || "application/octet-stream",
          contentBase64: btoa(binary),
        };
      }),
    ),
  );
};

export const attachmentBlob = (
  file: MailAttachment,
  type = file.contentType,
) => {
  const [safe] = validateMailAttachments([file]);
  return new Blob(
    [Uint8Array.from(atob(safe.contentBase64), (c) => c.charCodeAt(0))],
    { type },
  );
};

export const formatMailFileSize = (size: number) =>
  size < 1024
    ? `${size} Б`
    : size < 1024 * 1024
      ? `${(size / 1024).toLocaleString("ru-RU", { maximumFractionDigits: 1 })} КБ`
      : `${(size / 1024 / 1024).toLocaleString("ru-RU", { maximumFractionDigits: 1 })} МБ`;
